import React, { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { ModalTypes } from './constants';
import { getModalType, getIsOpen, closeModal } from './store/modals';
import DeliveryStatusSeeMore from './pages/landing/containers/DeliveryStatusSeeMore';
import AssetsSeeMore from './pages/landing/containers/AssetsSeeMore';
import PerformanceSeeMore from './pages/landing/containers/PerformanceSeeMore';
import OverviewSeeMore from './pages/landing/containers/OverviewSeeMore';
import CreditSeeMore from './pages/landing/containers/CreditSeeMore';
import DeleteModal from './pages/urlShortener/containers/deleteModal';
import BulkDeleteModal from './pages/urlShortener/containers/bulkDeleteModal';
import BulkDetailsDeleteModal from './pages/urlShortener/containers/bulkDetailsDeleteModal';
import SmsTemplateDeleteModal from './pages/channels/SMS/containers/templateDelete';
import SmsSenderIdsDeleteModal from './pages/channels/SMS/containers/senderIdDelete';
import DeleteConfiguration from './pages/channels/SMS/containers/receive-message/deleteConfiguration';
import PublishConfiguration from './pages/channels/SMS/containers/receive-message/publishConfiguration';
import CancelConfigurationFormModal from './pages/channels/SMS/containers/receive-message/cancelConfigurationFormModal';
import CallbackProfileModal from './pages/channels/Whatsapp/containers/callbackProfileModal';

const modals = {
	[ModalTypes.deliveryStatusSeeMore]: DeliveryStatusSeeMore,
	[ModalTypes.assetsSeeMore]: AssetsSeeMore,
	[ModalTypes.creditSeeMore]: CreditSeeMore,
	[ModalTypes.performanceSeeMore]: PerformanceSeeMore,
	[ModalTypes.overviewSeeMore]: OverviewSeeMore,
	[ModalTypes.delete]: DeleteModal,
	[ModalTypes.smsTemplateDelete]: SmsTemplateDeleteModal,
	[ModalTypes.smsSenderIdsDelete]: SmsSenderIdsDeleteModal,
	[ModalTypes.bulkDelete]: BulkDeleteModal,
	[ModalTypes.bulkDetailsDelete]: BulkDetailsDeleteModal,
	[ModalTypes.deleteConfiguration]: DeleteConfiguration,
	[ModalTypes.publishConfiguration]: PublishConfiguration,
	[ModalTypes.cancelConfigurationForm]: CancelConfigurationFormModal,
	[ModalTypes.callbackProfileModal]: CallbackProfileModal
};

const RootModal: React.FC = () => {
	const modalType = useSelector(getModalType);
	const isOpen = useSelector(getIsOpen);
	const closeDispatch = useDispatch();
	const onClose = useCallback(() => closeDispatch(closeModal()), [
		closeDispatch,
	]);

	const Component = modalType && modals[modalType];

	return <>{Component && <Component visible={isOpen} onClose={onClose} />}</>;
};

export default RootModal;
